<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-28 01:40 -->
<!-- Description:  -->
<template>
  <div>
    <select v-model="modelValue" class="custom-select">
      <option value=""></option>
      <option v-for="(item, k) in list" :key="k" :value="k">
        {{ item.name }}
      </option>
    </select>
  </div>
</template>
<script>
// script content
export default {
  name: "ContractSelect",
  components: {
    //
  },

  // directives

  props: {
    value: {}
  },

  data: () => ({
    list: [],
  }),

  computed: {
    modelValue: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); }
    }
  },

  // watch: {},

  mounted() {
    this.list = this.$store.state.config.admin.employee.contracts;
  },

  methods: {
    //
    //
    //
  }
};
</script>
<style scoped></style>

